import { Injectable } from '@angular/core';
import { SyrianLocationResolver } from '../../../shared/syrian-locations/syrian-location';

@Injectable({ providedIn: 'root' })
export class SyrianLocationService extends SyrianLocationResolver {}
